import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SplashScreen } from "./components/SplashScreen";
import { EventBanner } from "./components/EventBanner";
import { ScrollToTop } from "./components/ScrollToTop";
import { Home } from "./pages/Home";
import Careers from "./pages/Careers";
import { FormGate } from "./components/FormGate";
import { About } from "./pages/About";
import { CEOMessage } from "./pages/CEOMessage";
import { OrganisationChart } from "./pages/OrganisationChart";
import { Services } from "./pages/Services";
import { Production } from "./pages/services/Production";
import { Integrated } from "./pages/services/Integrated";
import { Capabilities } from "./pages/Capabilities";
import { RD } from "./pages/capabilities/RD";
import { Purifications } from "./pages/capabilities/Purifications";
import { Facility } from "./pages/capabilities/Facility";
import { ProductionPlants } from "./pages/capabilities/ProductionPlants";
import { Industries } from "./pages/Industries";
import { Semiconductor } from "./pages/industries/Semiconductor";
import { Display } from "./pages/industries/Display";
import { PersonalCare } from "./pages/industries/PersonalCare";
import { Brands } from "./pages/Brands";
import { Events } from "./pages/Events";
import { GetInTouch } from "./pages/GetInTouch";
import { Lumi } from "./pages/Lumi";
import { Partner } from "./pages/Partner";
import { CRDMOForm } from "./pages/partner/CRDMOForm";
import { CDMOForm } from "./pages/partner/CDMOForm";
import { CMOForm } from "./pages/partner/CMOForm";
import { PurificationForm } from "./pages/partner/PurificationForm";
import { TechConsultationForm } from "./pages/partner/TechConsultationForm";
import { BecomePartnerForm } from "./pages/partner/BecomePartnerForm";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { Toaster } from "./components/ui/sonner";
import { OrganizationJsonLd } from "./components/SEO";
import HowWeWork from "./pages/HowWeWork";
import Quality from "./pages/Quality";
import Products from "./pages/Products";
import { Cda } from "./pages/Cda";
import { CosmeticsActivesForm } from "./pages/partner/CosmeticsActivesForm";
import { CosmeticActives, CosmeticActiveDetail } from "./pages/products/CosmeticActives";

function App() {
  // Skip splash screen during prerender so static HTML contains the real page content.
  const isPrerender =
    typeof window !== 'undefined' && window.__IS_PRERENDER__;
  const SPLASH_ENABLED = false;
  const [showSplash, setShowSplash] = useState(SPLASH_ENABLED && !isPrerender);

  return (
    <div className="App">
        <OrganizationJsonLd />
        <EventBanner />
        {showSplash && (
          <SplashScreen onComplete={() => setShowSplash(false)} />
        )}
        <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/ceo-message" element={<CEOMessage />} />
          <Route path="/organisation-chart" element={<OrganisationChart />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/production" element={<Production />} />
          <Route path="/services/integrated" element={<Integrated />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/capabilities/rd" element={<RD />} />
          <Route path="/capabilities/purifications" element={<Purifications />} />
          <Route path="/capabilities/facility" element={<Facility />} />
          <Route path="/capabilities/production-plants" element={<ProductionPlants />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/semiconductor" element={<Semiconductor />} />
          <Route path="/industries/display" element={<Display />} />
          <Route path="/industries/personal-care" element={<PersonalCare />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/company/events" element={<Events />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/partner/crdmo" element={<FormGate><CRDMOForm /></FormGate>} />
          <Route path="/partner/cdmo" element={<FormGate><CDMOForm /></FormGate>} />
          <Route path="/partner/cmo" element={<FormGate><CMOForm /></FormGate>} />
          <Route path="/partner/purification" element={<FormGate><PurificationForm /></FormGate>} />
          <Route path="/partner/technical-consultation" element={<FormGate><TechConsultationForm /></FormGate>} />
          <Route path="/partner/become-partner" element={<FormGate><BecomePartnerForm /></FormGate>} />
          <Route path="/partner/cosmetic-actives" element={<FormGate><CosmeticsActivesForm /></FormGate>} />
          <Route path="/products/cosmetic-actives" element={<CosmeticActives />} />
          <Route path="/products/cosmetic-actives/:slug" element={<CosmeticActiveDetail />} />
          <Route path="/cda" element={<Cda />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/get-in-touch" element={<GetInTouch />} />
          <Route path="/lumi" element={<Lumi />} />
          <Route path="/how-we-work" element={<HowWeWork />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/products" element={<Products />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;

